import {useState} from "react";
import {useSelector} from "react-redux";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";
import {IconMapPin} from "@rw/icons";
import {carsTheme} from "@rw/themes";

import {IStore} from "../../../app/reducers/hybrid_reducer";
import {apiLink} from "../../../app/routes/api_link";
import {getRequest} from "../../../app/utils/request_response_utils/request";
import {getSellerUrl} from "../../utils/get_seller_slug";

interface IUserInfoProps {
    name: string;
    id: number;
}

export const UserInfo = (props: IUserInfoProps) => {
    const [userNumber, setUserNumber] = useState<string | number>("Wyświetl numer");
    const [numberRevealed, setNumberRevealed] = useState<boolean>(false);
    const {wojew, city} = useSelector((store: IStore) => store.offer.car.data.acf);
    const sellerLocation = `Woj. ${wojew},<br/>${city}`;
    const sellerUrl = props.name ? getSellerUrl(props.name) : null;
    const revealNumberHandler = () => {
        const url = apiLink.revealNumber({})({id: props.id});
        return getRequest({}, url, "revealNumber")
            .then((response: any) => {
                if (response) {
                    setUserNumber(response.phone_number);
                    setNumberRevealed(true);
                }
            })
            .catch((err) => {
                console.log("Error", err);
                return null;
            });
    };

    return (
        <div css={userInfoContainer}>
            <p css={sellerLabel}>Sprzedający</p>
            {props.name ? (
                sellerUrl ? (
                    <a href={sellerUrl} css={sellerNameLink}>
                        {props.name}
                    </a>
                ) : (
                    <p css={sellerNamePlain}>{props.name}</p>
                )
            ) : null}

            <button onClick={revealNumberHandler} css={revealButton}>
                {numberRevealed ? <a href={`tel:${userNumber}`}>{userNumber}</a> : userNumber}
            </button>

            {sellerUrl ? (
                <a href={sellerUrl} css={allOffersLink}>
                    Zobacz wszystkie oferty sprzedawcy
                </a>
            ) : null}

            <IconWrapper>
                <IconMapPin />
                <address>
                    <div dangerouslySetInnerHTML={{__html: sellerLocation}} />
                </address>
            </IconWrapper>
        </div>
    );
};

export const IconWrapper = styled.div`
    margin: 2rem 1rem 0 0;
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;

    .svg-icon {
        height: 27px;
        width: 27px;
        flex-shrink: 0;
    }

    address {
        font-style: normal;
        line-height: 1.5;
    }

    address div {
        white-space: pre-line;
    }
`;

const userInfoContainer = (theme: Theme) => css`
    margin-bottom: 2rem;
    @media (min-width: ${theme.breakpoints.screen_md}) {
        padding: 1rem 0;
        margin-bottom: 1rem;
    }
`;

const sellerLabel = css`
    margin: 0 0 0.35rem;
    font-size: 14px;
    color: #66676c;
`;

const sellerNameLink = (theme: Theme) => css`
    display: inline-block;
    margin: 0 0 0.25rem;
    font-size: 18px;
    font-weight: 700;
    color: ${theme.colors.brand_black};
    text-decoration: none;
    line-height: 1.3;

    &:hover {
        color: ${carsTheme.colors.brand_primary};
        text-decoration: underline;
    }
`;

const sellerNamePlain = css`
    margin: 0 0 0.25rem;
    font-size: 18px;
    font-weight: 700;
    color: #333;
    line-height: 1.3;
`;

const allOffersLink = (theme: Theme) => css`
    display: inline-block;
    margin-top: 0.65rem;
    font-size: 14px;
    color: ${theme.colors.brand_primary};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;

const revealButton = (theme: Theme) => css`
    display: flex;
    border: 2px solid ${theme.colors.text_color};
    height: 42px;
    align-items: center;
    justify-content: flex-start;
    padding: 20px;
    bottom: 50px;
    background: #fff;
    font-weight: 600;
    margin-top: 1rem;

    font-size: 16px;
    color: ${theme.colors.brand_black};

    border-radius: 4px;
    cursor: pointer;

    &:hover {
        color: ${carsTheme.colors.brand_black};
        border-color: ${carsTheme.colors.brand_primary};
        cursor: pointer;
    }
`;
